var _circle, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBadgeReminder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "url(#paint0_linear_3963_6620)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.69141,
    y: 3.69141,
    width: 8.61539,
    height: 8.61539,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3963_6620",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3963_6620",
    x1: 8,
    y1: 0,
    x2: 8,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AC772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06E5E5",
    stopOpacity: 0.718854
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3963_6620",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAABmJLR0QA/wD/AP+gvaeTAAADfUlEQVR4nO3dvYoUQRSG4bcVBb0CU38SQ0NDYzMTR1TUUG/ITBB/dhU0M1cvQENT8RYUDUQ+g9mCYZmu7a4+p6tm+rywwdJDd+1DUVNL0zMQRVEURVEUHSWpk3RH0mdJv45+Pkla1R7b3iTpjKSX6u+FpDO1x7nTSTot6SCDnHoX2IWNQA7s0gqQA3tsE5ADe2gGyIF9UobIgd2XA3JgH88RObBTMyAH9ozIy8WugLw87IrIy8FuADm1v9hqBzm1f9hqDzm1P9hqFzm1+9iyQ36QucZDg/O7Y5/yOrGk08ALwOJ209nCY0O7BRx6YrtAbyDfMTqlNzQ4Y5tDOyAD5P54Sxg3bFNoJ2SYZ0anXLDNoB2RYV5ocMA2gXZGhvmWjs1MsSdDz4AMdaDBEHsS9EzIMP/SsZkJdjH0jMhQFxoMsIugZ0aG+tAwEXs0dAVkqLdGH68YexR0JWRoY0anirAHQ1dEhragoQB7EHRlZGhn6dhsFPaJ0A0gQ3szOjUYOwvdCDK0Cw0DsXuhJXXAc+ojQx6zhbsjt4BnuRfkZvQKuGs6nPJantGpe5Ju9x3MQT9xGExpuVnbCjTA474DOehrDgMpbRdmNGTMctByGEhpLW7vttVrloP+4jCQ0nZlRn/tO5CDfuowkNJa33Wkes1y0G+AV/ZjKWoXZvSrruve9h3she66TsAD4MBjVCNrfdfxHniUe0H2P8Ou6/4B96mP3fKMfg+suq77m3tRN+RMDf0r3lqDkGEgNAT2lgYjwwhoCOyNRiHDSGgIbAqQoQAaFo1dhAyF0LBI7GJkmAANi8KehAwToWER2JORwQAa1p97BByyvtPg1W/gA/Dt6PerwE3gvOM1TZBN0/pDpt4ZPE+yre+SLm255mVJP5yu2e5DRPLD7l2WtP6YNuvaRU7JB/ti5noXjK/lgmz+DMvRerZivb5ZlbvbY3knyG1NdnkqywH7eubYDaNrtPfGNzTZLSPfJV3ecv4rsnkzdF+TTbZ3uWS39fvD9u3duYnn3d2ZfDytH1V+bTDzrGt/dzE2tYe9f8gptYO9v8gp1cfef+RURezlIKcqYC8POTUj9nKRUzNgB3LKETuQj+eAHch9GWIH8kkZYAfy0CZgB/LYCrADubQR2IE8NZ38FU4vA9korb+UbKX1F5H9kvRT0kdlHqCMoiiKoihaZv8B2Iks+B7GnVIAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBadgeReminder);
export default __webpack_public_path__ + "static/media/ic_badge_reminder.57570663b06a12676bdb1d3fa18a661e.svg";
export { ForwardRef as ReactComponent };